import { jsx as _jsx } from "react/jsx-runtime";
import { getStorage, setStorage, StorageKeys } from '@/utils';
import { noop } from 'lodash-es';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
export var Language;
(function (Language) {
    Language["En"] = "en";
    Language["Zh"] = "zh";
    Language["Jp"] = "jp";
})(Language || (Language = {}));
function getInitLang() {
    const storagedLang = getStorage(StorageKeys.Language);
    const urlLang = new URLSearchParams(location.search).get('lang');
    return (storagedLang ?? urlLang ?? navigator.language.split('-')[0]);
}
const initLang = getInitLang();
export const I18nContext = createContext({
    language: initLang,
    setLanguage: noop,
});
export function useI18n() {
    return useContext(I18nContext);
}
export const I18nProvider = ({ children }) => {
    const [language, setLanguage] = useState(initLang);
    const contextValue = useMemo(() => {
        return {
            language,
            setLanguage: (lang) => {
                setLanguage(lang);
                setStorage(StorageKeys.Language, lang);
            },
        };
    }, [language]);
    return _jsx(I18nContext.Provider, { value: contextValue, children: children });
};
export function createLocales(configs) {
    return function useLocales() {
        const { language } = useI18n();
        const t = useCallback((key, data) => {
            const config = configs[language] ?? {};
            let text = config[key] || configs.en?.[key] || key;
            if (process.env.NODE_ENV === 'development' && !configs.en?.[key]) {
                console.error(`No locale config for ${key}`);
            }
            if (data) {
                text = text.replace(/{(.*?)}/g, (_, key) => data[key] ?? key);
            }
            const mightBeHtml = /(<.*?>|&\w+;)/.test(text);
            return mightBeHtml
                ? (_jsx("span", { dangerouslySetInnerHTML: { __html: text } }))
                : text;
        }, [language]);
        return t;
    };
}
